module.exports = __webpack_public_path__ + "img/hidden_moon_2_new.c163e99d.jpg";